// extracted by mini-css-extract-plugin
module.exports = {"footer":"ConfirmationModalFooter_footer_WnTXi"};